import { render, staticRenderFns } from "./coursesView.vue?vue&type=template&id=4fbf27de"
import script from "./coursesView.vue?vue&type=script&lang=js"
export * from "./coursesView.vue?vue&type=script&lang=js"
import style0 from "./coursesView.vue?vue&type=style&index=0&id=4fbf27de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports